import { WaypointStepModel } from "./WaypointStep.model";

export class WaypointStep extends WaypointStepModel {
    // Add custom methods here
}
